module.exports = __webpack_public_path__ + "static/media/icon_214.8d823ad1.svg";